/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterStatScheduleDto } from '../../models/center-stat-schedule-dto';

export interface CenterStatControllerGetCounselingStat$Params {
  startAt: string;
  endAt: string;
  centerId: string;
  childIds: Array<string>;
}

export function centerStatControllerGetCounselingStat(http: HttpClient, rootUrl: string, params: CenterStatControllerGetCounselingStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterStatScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, centerStatControllerGetCounselingStat.PATH, 'get');
  if (params) {
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('centerId', params.centerId, {});
    rb.query('childIds', params.childIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterStatScheduleDto>;
    })
  );
}

centerStatControllerGetCounselingStat.PATH = '/api/center-stat/counseling';
